'use client';

import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth-store';
import { useAuthHydration } from '@/hooks/use-auth-hydration';
import { Loader2 } from 'lucide-react';

export default function InstitutionLayout() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const { isHydrated, isLoadingUser } = useAuthHydration();

  useEffect(() => {
    if (!isHydrated || isLoadingUser) return;
    if (!user) return;
    if (user.activeRole !== 'INSTITUTION') {
      navigate('/dashboard', { replace: true });
      return;
    }
    if (!user.institutionId) {
      navigate('/dashboard/institution-no-binding', { replace: true });
    }
  }, [isHydrated, isLoadingUser, user, navigate]);

  if (!isHydrated || isLoadingUser) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return <Outlet />;
}
